import type TableQuery from 'mini-mail-list-store/lib/store/schema/TableQuery';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

export default function shouldFolderSortByRenewTime(folderId: string): boolean {
    // Folder id should not be null if not in search mode
    if (!folderId) {
        throw new Error('Current folder id should not be null');
    }

    // Don't support pinned items in folders
    return false;
}

export function shouldTableSortByRenewTime(tableQuery: TableQuery) {
    // Allow pinning support in search mode
    if (tableQuery.type === 1) {
        return true;
    }

    return shouldFolderSortByRenewTime(tableQuery.folderId);
}
